export default function DashboardPage(props) {
  return null;
}
